export default __webpack_public_path__ + "static/media/duration-icon.d49afc4f.svg";